// This file is auto-generated by @hey-api/openapi-ts

import type { ContractedProductSearchResponse, GetCustomerOrderHistoryResponse, GetCustomerPositiveListResponse, GetFavoriteListFullResponse, GetFavoriteListsResponse, GetOrderResponse, ProductSearchResponse, QuickSearchResponse, SearchAppropriationsResponse } from './types.gen';

const priceDtoSchemaResponseTransformer = (data: any) => {
    if (data.minQuantity) {
        data.minQuantity = BigInt(data.minQuantity.toString());
    }
    if (data.maxQuantity) {
        data.maxQuantity = BigInt(data.maxQuantity.toString());
    }
    return data;
};

const priceRangeDtoSchemaResponseTransformer = (data: any) => {
    if (data.maxPrice) {
        data.maxPrice = priceDtoSchemaResponseTransformer(data.maxPrice);
    }
    if (data.minPrice) {
        data.minPrice = priceDtoSchemaResponseTransformer(data.minPrice);
    }
    return data;
};

const silWebProductDtoSchemaResponseTransformer = (data: any) => {
    if (data.price) {
        data.price = priceDtoSchemaResponseTransformer(data.price);
    }
    if (data.volumePrices) {
        data.volumePrices = data.volumePrices.map((item: any) => priceDtoSchemaResponseTransformer(item));
    }
    if (data.priceRange) {
        data.priceRange = priceRangeDtoSchemaResponseTransformer(data.priceRange);
    }
    if (data.basePrice) {
        data.basePrice = priceDtoSchemaResponseTransformer(data.basePrice);
    }
    if (data.discountedPrice) {
        data.discountedPrice = priceDtoSchemaResponseTransformer(data.discountedPrice);
    }
    if (data.volumeDiscounts) {
        data.volumeDiscounts = data.volumeDiscounts.map((item: any) => priceDtoSchemaResponseTransformer(item));
    }
    return data;
};

const paginationDtoSchemaResponseTransformer = (data: any) => {
    if (data.totalResults) {
        data.totalResults = BigInt(data.totalResults.toString());
    }
    return data;
};

const productSearchResultDtoSchemaResponseTransformer = (data: any) => {
    if (data.results) {
        data.results = data.results.map((item: any) => silWebProductDtoSchemaResponseTransformer(item));
    }
    if (data.pagination) {
        data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    }
    return data;
};

export const productSearchResponseTransformer = async (data: any): Promise<ProductSearchResponse> => {
    data = productSearchResultDtoSchemaResponseTransformer(data);
    return data;
};

const quickSearchResultDtoSchemaResponseTransformer = (data: any) => {
    if (data.products) {
        data.products = data.products.map((item: any) => silWebProductDtoSchemaResponseTransformer(item));
    }
    return data;
};

export const quickSearchResponseTransformer = async (data: any): Promise<QuickSearchResponse> => {
    data = quickSearchResultDtoSchemaResponseTransformer(data);
    return data;
};

const orderSummaryListDtoSchemaResponseTransformer = (data: any) => {
    data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    return data;
};

export const getCustomerOrderHistoryResponseTransformer = async (data: any): Promise<GetCustomerOrderHistoryResponse> => {
    data = orderSummaryListDtoSchemaResponseTransformer(data);
    return data;
};

const favoriteListsListDtoSchemaResponseTransformer = (data: any) => {
    if (data.pagination) {
        data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    }
    return data;
};

export const getFavoriteListsResponseTransformer = async (data: any): Promise<GetFavoriteListsResponse> => {
    data = favoriteListsListDtoSchemaResponseTransformer(data);
    return data;
};

const favoriteListResponseFullDtoSchemaResponseTransformer = (data: any) => {
    if (data.products) {
        data.products = data.products.map((item: any) => silWebProductDtoSchemaResponseTransformer(item));
    }
    if (data.pagination) {
        data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    }
    return data;
};

export const getFavoriteListFullResponseTransformer = async (data: any): Promise<GetFavoriteListFullResponse> => {
    data = favoriteListResponseFullDtoSchemaResponseTransformer(data);
    return data;
};

const appropriationLineDtoSchemaResponseTransformer = (data: any) => {
    if (data.product) {
        data.product = silWebProductDtoSchemaResponseTransformer(data.product);
    }
    return data;
};

const appropriationDtoSchemaResponseTransformer = (data: any) => {
    if (data.lines) {
        data.lines = data.lines.map((item: any) => appropriationLineDtoSchemaResponseTransformer(item));
    }
    return data;
};

const appropriationListDtoSchemaResponseTransformer = (data: any) => {
    if (data.results) {
        data.results = data.results.map((item: any) => appropriationDtoSchemaResponseTransformer(item));
    }
    if (data.pagination) {
        data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    }
    return data;
};

export const searchAppropriationsResponseTransformer = async (data: any): Promise<SearchAppropriationsResponse> => {
    data = appropriationListDtoSchemaResponseTransformer(data);
    return data;
};

export const contractedProductSearchResponseTransformer = async (data: any): Promise<ContractedProductSearchResponse> => {
    data = productSearchResultDtoSchemaResponseTransformer(data);
    return data;
};

const positiveListResponseDtoSchemaResponseTransformer = (data: any) => {
    if (data.results) {
        data.results = data.results.map((item: any) => silWebProductDtoSchemaResponseTransformer(item));
    }
    if (data.pagination) {
        data.pagination = paginationDtoSchemaResponseTransformer(data.pagination);
    }
    return data;
};

export const getCustomerPositiveListResponseTransformer = async (data: any): Promise<GetCustomerPositiveListResponse> => {
    data = positiveListResponseDtoSchemaResponseTransformer(data);
    return data;
};

const orderLineDtoSchemaResponseTransformer = (data: any) => {
    if (data.product) {
        data.product = silWebProductDtoSchemaResponseTransformer(data.product);
    }
    return data;
};

const orderDtoSchemaResponseTransformer = (data: any) => {
    data.orderLines = data.orderLines.map((item: any) => orderLineDtoSchemaResponseTransformer(item));
    return data;
};

export const getOrderResponseTransformer = async (data: any): Promise<GetOrderResponse> => {
    data = orderDtoSchemaResponseTransformer(data);
    return data;
};
